export default __webpack_public_path__ + "static/media/logo.394b719a.svg";